import { Text } from "@/components/ui/text";
import { For, Show, createEffect, createMemo } from "solid-js";
import { useService } from "solid-services";
import { Grid } from "styled-system/jsx";
import { Post } from "../Post";
import { useComments } from "../state";
import type { CommentsAdapter, CommentTreeItem } from "../types";
import { BubbleItem } from "./Item";

interface BubbleCommentsProps {
  entityId?: string;
  adapter: CommentsAdapter;
}

function countAll(items: CommentTreeItem[]): number {
  return items.reduce((sum, item) => sum + 1 + countAll(item.replies), 0);
}

export default function BubbleComments(props: BubbleCommentsProps) {
  const { comments, commentsQuery, setContext } = useService(useComments)();
  const totalCount = createMemo(() => countAll(comments()));

  createEffect(() => {
    if (props.entityId && props.adapter) {
      setContext(props.entityId, props.adapter);
    }
  });

  return (
    <Show when={props.entityId} fallback={<Text>No Entity Id provided</Text>}>
      <Grid gap="18px">
        <Text fontSize="15.5px" fontWeight="800" letterSpacing="-.01em" color="editorialInk">
          {totalCount() > 0 ? `Comments (${totalCount()})` : 'Comments'}
        </Text>

        <Post />

        <Show when={!commentsQuery.isLoading} fallback={<Text color="editorialInk3">Loading comments…</Text>}>
          <Grid gap="20px">
            <For each={comments()}>
              {(comment) => <BubbleItem comment={comment} />}
            </For>
          </Grid>
        </Show>

        <Show when={comments().length === 0 && !commentsQuery.isPending}>
          <Text color="editorialInk3" textAlign="center" py="4" fontSize="13px">
            No comments yet. Start the conversation above.
          </Text>
        </Show>
      </Grid>
    </Show>
  );
}
